import Modal from 'components/Modal'
import PurchaseRedemptionTx from 'views/MemberProfile/ManualTx/PurchaseRedemptionTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalPurchaseRedemption = ({ title, open, onClose }: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <PurchaseRedemptionTx onClose={onClose} />
    </Modal>
  )
}

export default ModalPurchaseRedemption
